<!--系统管理页面弹窗组件  :rules="rules"-->
<template>
    <el-dialog
        title="添加咨询工单"
        :visible="show"
        width="44%"
        @close="closeWindow"
        class="dialog_container"
    >
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
        >
            <div class="display">
                <el-form-item label="工单流水号：" prop="gdlsh">
                    <el-input
                        v-model="ruleForm.gdlsh"
                        :disabled="true"
                    ></el-input>
                </el-form-item>
                <el-form-item label="来电时间：" prop="callTime">
                    <el-input v-model="ruleForm.callTime"></el-input>
                </el-form-item>
            </div>
            <div class="display">
                <el-form-item label="咨询客户：" prop="customer">
                    <el-input
                        v-model="ruleForm.customer"
                        @focus="customer()"
                    ></el-input>
                </el-form-item>
                <el-form-item label="来电号码：" prop="callPhone">
                    <el-input v-model="ruleForm.callPhone"></el-input>
                </el-form-item>
            </div>
            <div class="display">
                <el-form-item label="受理人员：" prop="seatPerson">
                    <el-input v-model="ruleForm.seatPerson"></el-input>
                </el-form-item>
                <el-form-item label="咨询类别：" prop="adviceType">
                    <el-select v-model="ruleForm.adviceType">
                        <el-option
                            v-for="item in ZXTypeList"
                            :label="item.typeName"
                            :value="item.ids"
                            :key="item.index"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="display">
                <el-form-item label="咨询备注：" prop="remark">
                    <el-input v-model="ruleForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="受理坐席：" prop="slzx">
                    <el-input
                        v-model="ruleForm.slzx"
                        :disabled="true"
                    ></el-input>
                </el-form-item>
            </div>
            <div class="display">
                <el-form-item label="咨询内容：" prop="adviceContent">
                    <el-input v-model="ruleForm.adviceContent"></el-input>
                </el-form-item>
                <el-form-item label="咨询回复：" prop="adviceAnswer">
                    <el-input v-model="ruleForm.adviceAnswer"></el-input>
                </el-form-item>
            </div>
            <el-form-item>
                <div class="display-center">
                    <el-button type="primary" @click="submitForm('ruleForm')"
                        >保存</el-button
                    >
                    <el-button @click="closeWindow('ruleForm')"
                        >取 消</el-button
                    >
                </div>
            </el-form-item>
        </el-form>
        <div v-if="showCustomer" class="dialog_customer">
            <el-form :model="formInline" class="demo-form-inline">
                <div class="display-left">
                    <div style="width: 200px">
                        <el-form-item label="姓名">
                            <el-input v-model="formInline.name"></el-input>
                        </el-form-item>
                    </div>
                    <div style="width: 200px">
                        <el-form-item label="地址">
                            <el-input v-model="formInline.address"></el-input>
                        </el-form-item>
                    </div>
                    <div style="width: 200px">
                        <el-form-item label="联系方式">
                            <el-input v-model="formInline.phone"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="display-left">
                    <div style="width: 200px">
                        <el-form-item label="用户类型">
                            <el-select
                                v-model="formInline.type"
                                style="width: 100px"
                            >
                                <el-option
                                    label="老干客户"
                                    value="1"
                                ></el-option>
                                <el-option
                                    label="民政客户"
                                    value="2"
                                ></el-option>
                                <el-option
                                    label="商业客户"
                                    value="3"
                                ></el-option>
                                <el-option
                                    label="残联客户"
                                    value="4"
                                ></el-option>
                                <el-option
                                    label="文明办客户"
                                    value="5"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div style="width: 200px">
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit"
                                >查询</el-button
                            >
                            <el-button type="primary" @click="onClose"
                                >关闭</el-button
                            >
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <el-table :data="tableData" style="width: 100%">
                <el-table-column label="序号" type="index" width="50">
                </el-table-column>
                <el-table-column prop="name" label="姓名" width="100">
                </el-table-column>
                <el-table-column prop="province" label="联系方式" width="120">
                </el-table-column>
                <el-table-column prop="city" label="是否实体" width="100">
                </el-table-column>
                <el-table-column prop="address" label="用户类型" width="100">
                </el-table-column>
                <el-table-column prop="zip" label="地址" width="120">
                </el-table-column>
                <el-table-column fixed="right" label="操作对象" width="80">
                    <template slot-scope="scope">
                        <el-button
                            @click="handleClick(scope.row)"
                            type="text"
                            size="small"
                            >选择</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <Paginationmini
                :pageConfig="pageConfig"
                @currentPage="currentChange"
                @pageSize="pageSizeChange"
            ></Paginationmini>
        </div>
    </el-dialog>
</template>
<script>
import request from "@/utils/request.js"
import Paginationmini from "./pagination-mini"
export default {
    name: "AddConsulting",
    props: {
        showConsulting: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showCustomer: false,
            ruleForm: {},
            rules: {
                callTime: [
                    {
                        required: true,
                        message: "请输入来电时间",
                        trigger: "blur",
                    },
                ],
                adviceContent: [
                    {
                        required: true,
                        message: "请输入咨询内容",
                        trigger: "blur",
                    },
                ],
                adviceAnswer: [
                    {
                        required: true,
                        message: "请输入咨询回复",
                        trigger: "blur",
                    },
                ],
            },
            ZXTypeList: [], //咨询类别
            formInline: {},
            pageConfig: {
                pageSize: 4,
                total: 0,
                pageNo: 1,
            },
            tableData: [],
        }
    },
    components: {
        Paginationmini,
    },
    computed: {
        show() {
            return this.showConsulting
        },
    },
    created() {
        var date = new Date()
        var year = date.getFullYear()
        var month = date.getMonth() + 1 //js中是从0开始所以要加1
        var day = date.getDate()
        var hour = date.getHours()
        var minute = date.getMinutes()
        var second = date.getSeconds()
        this.ruleForm.callTime =
            year +
            "-" +
            month +
            "-" +
            day +
            " " +
            hour +
            ":" +
            minute +
            ":" +
            second
        this.ruleForm.seatPerson = JSON.parse(
            localStorage.getItem("czUserInfo")
        ).loginName
        //  this.ruleForm.customer =  localStorage.getItem('zxName')
        this.getZXTypeList()
        this.getZXKHList()
    },
    methods: {
        handleClick(val) {
            this.ruleForm.customer = val.name
            this.showCustomer = false
        },
        //通话记录页码改变
        currentChange(currentPage) {
            this.pageConfig.pageNo = currentPage
            this.getZXKHList()
        },
        pageSizeChange(size) {
            this.pageConfig.pageSize = size
            this.getZXKHList()
        },
        onSubmit() {
            this.getZXKHList()
        },
        getZXKHList() {
            request({
                url: "/jjyl/WebCustomer/info/findCustomer",
                method: "POST",
                data: {
                    ...this.formInline,
                    belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
                    pageNo: this.pageConfig.pageNo,
                    pageSize: this.pageConfig.pageSize,
                },
            }).then((resp) => {
                if (resp.code == "200") {
                    if (resp.content != null) {
                        this.tableData = resp.content.list
                        this.pageConfig.total = resp.content.count
                    } else {
                        this.tableData = []
                    }
                }
            })
        },
        customer() {
            this.showCustomer = true
        },
        onClose() {
            this.showCustomer = false
        },
        //咨询类别列表
        getZXTypeList() {
            request({
                url: "/jjyl/adviceType/info/findAdviceType",
                method: "POST",
                data: {
                    belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
                    pageNo: 1,
                    pageSize: 50,
                },
            }).then((resp) => {
                if (resp.code == "200") {
                    if (resp.content != null) {
                        this.ZXTypeList = resp.content.list
                    } else {
                    }
                }
            })
        },
        //保存
        submitForm(formName) {
            this.tableData.forEach((item) => {
                if ((this.ruleForm.customer = item.name)) {
                    this.ruleForm.customer = item.ids
                }
            })
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    request({
                        url: "/jjyl/advicepgd/info/insertAdvicepgd",
                        method: "POST",
                        data: {
                            // customer:this.ruleForm.customer,
                            ...this.ruleForm,
                            belongAddressId:
                                "06a942d7-0241-4428-8f6f-bbf0695e60ae",
                            belongProvinceId:
                                localStorage.getItem("provinceId"),
                        },
                    }).then((resp) => {
                        if (resp.code == "200") {
                            this.closeWindow()
                            this.$emit("sXval", 2)
                            this.$message.success("新增成功")
                        } else {
                            this.$message({
                                showClose: true,
                                message: "新增咨询工单失败",
                                type: "error",
                                offset: 50,
                            })
                        }
                    })
                } else {
                    return false
                }
            })
        },

        closeWindow() {
            this.$emit("update:showConsulting", false)
        },
    },
}
</script>
<style lang="less" scoped>
.dialog_container {
    /deep/ .el-dialog__header {
        border-bottom: 1px solid #e5e5e5;
    }
}

.set-title {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    align-items: center;
}

.set-title > div:first-child {
    width: 110px;
    text-align: right;
}

.set-title > div:nth-child(2) {
    width: calc(100% - 110px);
}

.btn {
    width: 100%;
    display: flex;
    justify-content: center;
}
.display {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.display-center {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.el-input {
    width: 200px !important;
}
.dialog_customer {
    position: absolute;
    width: 600px;
    padding: 20px;
    border: 1px solid #999;
    border-radius: 5px;
    background: #ffffff;
    top: 200px;
    left: 180px;
    .el-input {
        width: 100px !important;
    }
    .display-left {
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
    }
}
</style>
